// extracted by mini-css-extract-plugin
module.exports = {"pdf":"styles_pdf__2E_so"};